import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { forgotPassword, verifyOTP, changeNewPassword } from 'api/login';
import { resendOTP } from 'api/profile';
import { useAuth } from 'hooks/useAuthContext';
import { useSnackbar } from 'components/snackbar';
import { maskPhoneNumber, maskEmail } from 'utils/Utils';
const loginLogo = `${process.env.REACT_APP_HOMEPAGE}assets/TJ-Logo-LightBG-withTagline 1.svg`;
const alertIcon = `${process.env.REACT_APP_HOMEPAGE}assets/icon-alert.svg`;
import SideBanner from 'components/basic-profile/SideBannerPage';

import { Box, FormControl, Link, Grid, IconButton, InputAdornment, OutlinedInput, SvgIcon, Button, Typography, Stack, Container, Icon, TextField, InputLabel, Divider, FormControlLabel, Checkbox, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';


import SlickSlider from 'react-slick';
import Typewriter from "typewriter-effect";
/**
 * EnterOTP is a React component that handles user input for a One-Time Password (OTP).
 * It verifies the entered OTP, allows resending of the OTP, and manages the UI state.
 * The component uses various hooks to handle authentication, navigation, and displaying
 * notifications. It also manages the countdown timer for resending the OTP and tracks
 * the number of OTP attempts.
 */

const EnterOTP = () => {
    const location = useLocation();
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const { method, user } = location.state;
    const { updateContext } = useAuth();
    const [otp, setOtp] = useState('');
    const [error, setError] = useState('');
    const [disable, setDisable] = useState(false);

    const [resendTimeout, setResendTimeout] = useState(60);
    const [attempts, setAttempts] = useState(0);
    const [sendingResentOtp, setSendingResentOtp] = useState(false);

    // updateContext

    useEffect(() => {
        const timer = setInterval(() => {
            setResendTimeout((prev) => Math.max(0, prev - 1));
        }, 1000);
        return () => clearInterval(timer);
    }, []);


    var settings = {
        autoplay: true,
        fade: true,
        autoplaySpeed: 3000,
        speed: 1000,
        prevArrow: false,
        nextArrow: false
    };

    /**
     * Handles changes to the OTP input field.
     * Verifies that the input consists of only numbers and has a maximum length of 6.
     * If the input is valid, updates the component state with the new OTP value.
     * @param {React.ChangeEvent<HTMLInputElement>} e - The React SyntheticEvent for the input change event.
     * @private
     */
    const handleChange = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value) && value.length <= 6) {
            setOtp(value);
        }
    };
    /**
     * Handles the submission of the OTP form.
     * Verifies the OTP with the server and updates the user state if the OTP is valid.
     * If the OTP is invalid, displays an error message and resets the OTP input field.
     * If the user has attempted to submit the OTP 3 times, disables the form and displays an
     * error message.
     * @private
     */
    const onSubmit = async () => {
        const formData = { otp, userId: user.id, method };
        const noRegex = /^\d{6}$/;
        if (!noRegex.test(otp)) {
            setDisable(false);
            setError('Please enter a valid OTP.');
            return;
        }
        const response = await verifyOTP(formData);
        if (response?.success && response.data) {
            if (method === 'otp') {
                updateContext({ ...response.data });
                navigate('/');
            }
            handleOpenOnboardedResumeDialog();
        } else {
            enqueueSnackbar(response.message, { variant: 'error' });
            setOtp('');

            if (attempts === 2) {
                enqueueSnackbar(response.message, { variant: 'error' });
                // reset();
                setOtp(false);
                // onCancelOTP();
                navigate('/');
            }
            setAttempts(attempts + 1);

        }
        setDisable(false);
    };

    /**
     * Handles the resend OTP button click.
     * Sends a request to the server to resend the OTP.
     * If the request is successful, displays a success message and resets the resend timeout.
     * If the request fails, displays an error message.
     * @private
     */
    const handleResend = async () => {
        try {
            setSendingResentOtp(true);

            const response = await resendOTP({ userId: user.id });

            if (response?.success) {
                enqueueSnackbar('OTP has been sent.', { variant: 'success' });
                setResendTimeout(45);
            } else {
                enqueueSnackbar('Failed to resend OTP.', { variant: 'error' });
            }
        } catch (error) {
            console.error('Error resending OTP:', error);
            enqueueSnackbar('An error occurred while resending OTP.', { variant: 'error' });
        } finally {
            setSendingResentOtp(false);
        }
    };

    return (
        <Box sx={{ overflow: 'hidden' }}>
            <Grid container justifyContent={'center'} alignItems={'center'}>
                <Grid item xs={12} md={6} lg={6} >
                    <Box className="login-page-wrapper">
                        <Box className="login-content-wrapper" sx={{ padding: { xs: '40px 20px', md: '40px' } }}>
                            <Box className="tj-logo" sx={{ marginBottom: { xs: '24px', md: '40px' } }} >
                                <Box
                                    mb={5}
                                    component="img"
                                    alt="Talent Junction"
                                    width="196px"
                                    height="61px"
                                    src={loginLogo}
                                />
                            </Box>

                            {/* Register form block */}
                            <Box className="register-form-wrapper forgot-password-form">
                                <Box sx={{ marginBottom: { xs: '24px', md: '40px' } }}>
                                    <Typography className="title">Enter OTP</Typography>
                                    <Typography className="info-text">
                                        {`Please enter the 6-digit OTP sent to ${user?.phone_number ? `your WhatsApp number +91-${maskPhoneNumber(user.phone_number)}` : ''
                                            }${user?.phone_number && user?.email ? ' and ' : ''
                                            }${user?.email ? `your email address ${maskEmail(user.email)}` : ''
                                            }.`}
                                    </Typography>
                                </Box>
                                <Stack spacing={2.5}>
                                    <FormControl size="small" fullWidth sx={{
                                        display: 'inline-flex',
                                        flexDirection: 'column',
                                        position: 'relative',
                                        minWidth: '0px',
                                        padding: '0px',
                                        margin: '0px',
                                        border: '0px',
                                        verticalAlign: 'top',
                                        width: '100%',
                                        height: '67px',
                                    }}>
                                        <TextField
                                            label="Enter OTP"
                                            value={otp}
                                            onChange={handleChange}
                                            size="small"
                                            variant="outlined"
                                            type="tel"
                                            inputProps={{
                                                inputMode: "numeric",
                                                pattern: "[0-9]*",
                                                maxLength: 6
                                            }}
                                        />
                                        {error && (
                                            <Box sx={{ marginBottom: "-1px" }}>
                                                <Typography size="small" className="error-text" component="p" style={{ color: "#FF4842", fontSize: "0.75rem", fontFamily: "Public Sans, sans-serif", fontWeight: 400, marginLeft: "14px" }}>
                                                    {error}
                                                </Typography>
                                            </Box>
                                        )}
                                    </FormControl>

                                    {/* Resend OTP Section */}
                                    <Box sx={{ marginBottom: { xs: "17px", md: "32px" } }}>
                                        <Stack direction="row" justifyContent={"space-between"} alignItems={"center"}>
                                            <Box>
                                                <Typography className="resend-otp-txt" component="p">
                                                    Resend OTP in: <Typography className="text-primary" component="span">{resendTimeout} secs</Typography>
                                                </Typography>
                                                {resendTimeout === 0 && (
                                                    <Box sx={{ textAlign: 'left' }}>
                                                        <button
                                                            type="button"
                                                            className="text-secondary resend-otp-link"
                                                            style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', color: '#1976d2', fontWeight: '600', fontSize: '14px' }}
                                                            disabled={sendingResentOtp}
                                                            onClick={handleResend}
                                                        >
                                                            Resend
                                                        </button>
                                                    </Box>
                                                )}
                                            </Box>
                                            <Box>
                                                <Stack direction="row" alignItems={"center"} spacing={1}>
                                                    <Box mb={5} component="img" alt="Talent Junction" src={alertIcon} />
                                                    <Typography className="attempts-txt" component="p">
                                                        {3 - attempts}/3 attempts left
                                                    </Typography>
                                                </Stack>
                                            </Box>
                                        </Stack>
                                    </Box>

                                    <Button
                                        type='submit'
                                        variant='contained'
                                        size='large'
                                        className="login-btn"
                                        disabled={disable}
                                        onClick={() => {
                                            setDisable(true);
                                            onSubmit();
                                        }}
                                    >
                                        Continue
                                    </Button>
                                </Stack>
                            </Box>
                        </Box>
                    </Box>
                </Grid>

                <Grid item xs={12} md={6} lg={6} sx={{ display: { xs: 'none', md: 'block' } }}>
                    <SideBanner />
                </Grid>
            </Grid>
        </Box >
    )
}

export default EnterOTP
